export const ONBOARDING_INTRO_EXPERIMENT_PROPERTY = "onboarding_intro_experiment_august";
export const PENDING_ONBOARDING_INTRO_ASSIGNMENT_STORAGE_KEY = "bx_pending_onboarding_intro_assignment";
